import C from './Constants';
import G from './Getters';

import getFilesystemMetadataArgs from './getFilesystemMetadataArgs';

import { CREATION_DATE, LAST_EDITED_DATE, CREATOR_ID, PERMISSIONS } from './FieldConstants';

export default function DefaultMetadata(state,args){


  state = state || {};
  let userRelatedMetadata = {};
  let { userId } = state.loginInfo || {};


  if( state && userId ){

    let groupId;
    if( args && args.creationContext && args.creationContext.groupId ){
      groupId = args.creationContext.groupId;
    }else{
      let workspaceInfo = G.getCurrentWorkspaceInfo(state);
       groupId = workspaceInfo.groupId;
    }


    let groupPermissions = groupId ? ({
      [groupId]:"computedAtGroup"
    }) : {}

    userRelatedMetadata = {
      [PERMISSIONS]:{ 
        [userId]:C.OWNER_PERMISSION,
        ...groupPermissions,

      },
      [CREATOR_ID]:userId,
    }


  }

  

  let extraArgsResult = getFilesystemMetadataArgs(state,args);


  let extraArgs = extraArgsResult.metaArgs;
  let error = extraArgsResult.error;

  if( error ){
    return {
      error
    }
  }
  
  //alldef({userId});
  let curDate = Number(Date.now());
    
  let metadata = {
    _id:args._id,
    versions:[],
    ...userRelatedMetadata,
    [CREATION_DATE]:curDate,
    [LAST_EDITED_DATE]:curDate,
    requiredAsByRole:{},
    requirementsByRole:{},
    ...extraArgs
  }

  return { meta: metadata };



}
